<template>
    <div class="Login-container">
        <div id="main" style="width: 380px;height:220px;"></div>
    </div>
</template>

<script>
    const echarts = require('echarts');
    export default {
        data() {
            return {
                list: []
            }
        },
        watch: {
            list(n) {
                this.init()
            }
        },
        mounted() {
            this.getData()
        },
        methods: {
            getData() {
                this.list = [{
                        "x": "03-10",
                        "y": "420"
                    },
                    {
                        "x": "03-12",
                        "y": "600"
                    },
                    {
                        "x": "03-13",
                        "y": "350"
                    },
                    {
                        "x": "03-14",
                        "y": "360"
                    },
                    {
                        "x": "03-15",
                        "y": "200"
                    },
                    {
                        "x": "03-16",
                        "y": "210"
                    }
                ]
            },
            init() {
                // 基于准备好的dom，初始化echarts实例
                var myChart = echarts.init(document.getElementById('main'));

                let xAxisData = []
                let seriesData = []

                this.list.forEach((i, k) => {
                    xAxisData.push(i.x || '')
                    seriesData.push(i.y || 0)
                })



                // 指定图表的配置项和数据
                let option = {
                    title: {
                        subtext: '单位：次',
                        subtextStyle: {
                            //文字颜色
                            color: '#74a0bf',
                            //字体大小
                            fontSize: 12
                        }
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: xAxisData,
                        axisLine: {
                            lineStyle: {
                                type: 'solid',
                                color: '#74a0bf', //左边线的颜色
                                width: '1' //坐标线的宽度
                            }
                        },
                        axisLabel: {
                            textStyle: {
                                // 坐标值得具体的颜色
                                color: '#74a0bf',
                                fontSize: 12
                            }
                        }
                    },
                    yAxis: {
                        type: 'value',
                        scale: false, //自适应
                        minInterval: 200, //分割刻度
                        max: function(value) { //取最大值向上取整为最大刻度
                            return Math.ceil(value.max + 200)
                        },
                        axisLine: {
                            lineStyle: {
                                type: 'solid',
                                color: '#74a0bf',
                                width: '1'
                            }
                        },
                        axisLabel: {
                            textStyle: {
                                color: '#74a0bf',
                                fontSize: 12
                            }
                        },
                        splitLine: {
                            show: true, //X网格线
                            lineStyle: { //x网格线
                                color: '#002d37'
                            }
                        }
                    },
                    series: [{
                        data: seriesData,
                        type: 'line',
                        areaStyle: {
                            opacity: 1,
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(175, 57, 79,1)'
                            }, {
                                offset: 1,
                                color: 'rgba(68, 36, 52,0.5)'
                            }])
                        },
                        lineStyle: {
                            color: '#f94762',
                            width: 2
                        },
                        // 圆弧
                        smooth: false,
                        // 拐点
                        symbol: 'none',
                    }],
                    showAllSymbol: 0
                };

                // 使用刚指定的配置项和数据显示图表。
                myChart.setOption(option);
            }
        }
    }
</script>

<style lang="less">
    #main {
        margin: 200px 50px;
        background-color: #051c2c;
        color: #74a0bf;
    }
</style>
